import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

type StepsBarProps = {
  count: number;
  percentageFilled: number;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
  width: 100%;
  height: 4px;
  margin-block-end: 16px;
`;

const Step = styled.div<{ filledPercentage: number }>`
  flex: 1;
  text-align: center;
  background: linear-gradient(
    to right,
    ${cbSemanticCssVars.textPrimary} ${({ filledPercentage }) => filledPercentage}%,
    ${cbSemanticCssVars.borderPrimary} ${({ filledPercentage }) => filledPercentage}%
  );
  height: 100%;
  margin-inline: 1px;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

const StepsBar = ({ count, percentageFilled }: StepsBarProps) => {
  const percentageInOneStepBar = 1 / count;
  const stepBarFillingPercentages = Array.from({ length: count }).map((_, index) => {
    const maxStepBarPercentage = (index + 1) * percentageInOneStepBar;
    if (maxStepBarPercentage <= percentageFilled) {
      return 100;
    }
    const minStepBarPercentage = maxStepBarPercentage - percentageInOneStepBar;
    if (minStepBarPercentage > percentageFilled) {
      return 0;
    }
    return ((percentageFilled - minStepBarPercentage) / percentageInOneStepBar) * 100;
  });
  return (
    <Wrapper>
      {stepBarFillingPercentages.map((filledPercentage, index) => (
        <Step data-testid="StepsBar-step" key={index} filledPercentage={filledPercentage} />
      ))}
    </Wrapper>
  );
};

export default StepsBar;
